import { router } from "@inertiajs/vue2";

const vueGlobalMethods = {
    inArray(needle, haystack) {
        let length = haystack.length;
        for (let i = 0; i < length; i++) {
            if (haystack[i] === needle) return true;
        }
        return false;
    },
    hasLiveProperties() {
        if (this.$page.props.properties) {
            return this.$page.props.properties.some(property => {
                return (
                    property.p_illustration_only === 0 &&
                    property.p_hold_status === 3
                );
            });
        } else if (this.$page.props.properties_summary) {
            return this.$page.props.properties_summary.live > 0;
        } else {
            return false;
        }
    },
    flattenObject(obj) {
        const flattenedValues = [];
        for (const key in obj) {
            if (Array.isArray(obj[key])) {
                flattenedValues.push(...obj[key]); // Spread operator to expand the array
            } else {
                flattenedValues.push(obj[key]);
            }
        }
        return flattenedValues;
    },
    hasPermission(permission) {
        return this.inArray(permission, this.$page.props.auth.user.permissions);
    },
    hasRole(role) {
        return this.inArray(role, this.$page.props.auth.user.roles);
    },
    canEditOwnerName() {
        //If manager edit any name
        if (
            this.hasRole("manager") ||
            this.hasRole("admin") ||
            this.hasRole("super admin")
        ) {
            return true;
        }
        //If owner has live properties staff can't edit name
        return !this.hasLiveProperties();
    },
    canEditOwnerPhone() {
        //If manager edit any phone
        if (
            this.hasRole("manager") ||
            this.hasRole("sales") ||
            this.hasRole("admin") ||
            this.hasRole("super admin")
        ) {
            return true;
        }
        //If owner has live properties staff can't edit name
        return !this.hasLiveProperties();
    },
    canEditOwnerEmail() {
        //If manager edit any phone
        if (
            this.hasRole("manager") ||
            this.hasRole("sales") ||
            this.hasRole("admin") ||
            this.hasRole("super admin")
        ) {
            return true;
        }
        //If owner has live properties staff can't edit email
        return !this.hasLiveProperties();
    },
    isInternal() {
        return !!(
            this.hasRole("manager") ||
            this.hasRole("sales") ||
            this.hasRole("admin") ||
            this.hasRole("super admin") ||
            this.hasRole("queue-picker")
        );
    },
    successSweetAlert(
        response,
        icon = "success",
        title = "Success",
        timer = 1200
    ) {
        this.$swal({
            position: "bottom-start",
            icon: icon,
            title: title,
            showConfirmButton: false,
            timer: timer
        });
    },
    errorSweetAlert(errors, icon = "error", title = "Something went wrong") {
        this.$swal({
            icon: icon,
            title: errors.response.data.message ?? title,
            showConfirmButton: true,
            allowOutsideClick: false
        });
    },
    reloadInertia(section = []) {
        if (section.length > 0) {
            router.reload({ only: section });
        } else {
            router.reload();
        }
    },
    isFutureDate(date) {
        return new Date(date) > new Date();
    },
    isPastDate(date) {
        return new Date(date) < new Date();
    },
    isValidDate(date) {
        return new Date(date) > new Date("1970-01-01");
    },
    formattedDate(date) {
        if (date === null) {
            return date;
        }
        let dateObject = new Date(date);
        return dateObject.toLocaleString("en-GB");
    },
    ucWords(string) {
        return string.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    },
    getAddressObject(address_components) {
        var ShouldBeComponent = {
            name_or_number: ["street_number"],
            postal_code: ["postal_code", "postal_code_suffix"],
            street_route: ["street_address", "route"],
            region_district: [
                "administrative_area_level_1",
                "administrative_area_level_2",
                "administrative_area_level_3",
                "administrative_area_level_4",
                "administrative_area_level_5"
            ],
            city_locality: [
                "locality",
                "postal_town",
                "sublocality",
                "sublocality_level_1",
                "sublocality_level_2",
                "sublocality_level_3",
                "sublocality_level_4"
            ],
            country: ["country"]
        };

        var address = {
            name_or_number: "",
            postal_code: "",
            street_route: "",
            region_district: "",
            city_locality: "",
            country: ""
        };
        if (address_components.length > 0) {
            address_components.forEach(component => {
                for (const shouldBe in ShouldBeComponent) {
                    if (
                        ShouldBeComponent[shouldBe].indexOf(
                            component.types[0]
                        ) !== -1
                    ) {
                        if (address[shouldBe] === "") {
                            //empty so save item
                            address[shouldBe] = component.long_name;
                        } else {
                            //not empty so append
                            address[shouldBe] =
                                component.types[0] === "postal_code_suffix"
                                    ? address[shouldBe] +
                                      "-" +
                                      component.long_name
                                    : address[shouldBe] +
                                      ", " +
                                      component.long_name;
                        }
                    }
                }
            });
            return address;
        } else return null;
    }
};

export default vueGlobalMethods;
